class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.closest('cart-items').updateQuantity(this.dataset.index, 0);
    });
  }
}
customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');
    this.cartErrors = document.getElementById('cart-errors');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    if (event.target === null) return;
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  getSectionsToRender() {
    let sections = [
      {
        id: 'mini-cart',
        section: document.getElementById('mini-cart')?.id,
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items')?.dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer')?.dataset.id,
        selector: '.js-contents',
      }
    ];
    if (document.querySelector('#main-cart-footer .free-shipping')) {
      sections.push({
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer')?.dataset.id,
        selector: '.free-shipping',
      });
    }
    return sections;
  }

  updateQuantity(line, quantity, name) {
  // Get the line item to check product type and tags (main cart)
  const lineItem = document.getElementById(`CartItem-${line}`);
  let min = 50;
  let step = 50;
  let productType = null;
  let productTags = [];

  // Main cart: read from #CartItem-{line}
  if (lineItem && lineItem.dataset.productType) {
    productType = lineItem.dataset.productType;
    // Get product tags from data attribute
    if (lineItem.dataset.productTags) {
      productTags = lineItem.dataset.productTags.split(',').map(tag => tag.trim());
    }
  } else {
    // Mini-cart: find the input by data-index, then get its container's data-product-type
    const miniInput = document.querySelector(`input[name="updates[]"][data-index="${line}"]`);
    const container = miniInput ? miniInput.closest('[data-product-type]') : null;
    if (container && container.dataset.productType) {
      productType = container.dataset.productType;
      // Get product tags from data attribute
      if (container.dataset.productTags) {
        productTags = container.dataset.productTags.split(',').map(tag => tag.trim());
      }
    }
  }

  // Check for tag-based rules first (highest priority)
  const hasMin300Tag = productTags.includes('min300');
  const hasMin200Tag = productTags.includes('min200');

  if (hasMin300Tag) {
    min = 300;
    step = 100;
  } else if (hasMin200Tag) {
    min = 200;
    step = 100;
  } else if (productType) {
    // Apply rules based on product type (lower priority)
    const typeLower = productType.toLowerCase();
    if (typeLower.includes('e-invitation') || typeLower.includes('einvitation') || typeLower.includes('e invitation')) {
      min = 1;
      step = 1;
    } else if (typeLower.includes('return gift') || typeLower.includes('return-gift') ||
               typeLower.includes('returngift') || typeLower.includes('return gifts') ||
               typeLower.includes('return-gifts') || typeLower.includes('returngifts') ||
               typeLower.includes('return_gift') || typeLower.includes('return_gifts')) {
      min = 10;
      step = 10;
    } else if (typeLower.includes('paper')) {
      min = 100;
      step = 100;
    } else if (typeLower.includes('wedding card') || typeLower.includes('wedding-card') ||
               typeLower.includes('weddingcard') || typeLower.includes('wedding cards') ||
               typeLower.includes('wedding-cards') || typeLower.includes('weddingcards')) {
      min = 100;
      step = 50;
    } else if (typeLower.includes('sale')) {
      min = 100;
      step = 50;
    }
  }
  
  // Apply quantity normalization based on rules
  if (quantity > 0 && quantity < min) {
    quantity = min;
  } else if (quantity > 0) {
    // Apply step rounding based on tag or product type
    if (hasMin300Tag || hasMin200Tag) {
      // Tag-based products - round to nearest 100
      if (!(quantity >= min && quantity % 100 === 0)) {
        quantity = Math.max(min, Math.round(quantity / 100) * 100);
      }
    } else if (min === 1 && step === 1) {
      // E-invitation products - no rounding needed
      quantity = Math.max(1, quantity);
    } else if (min === 10 && step === 10) {
      // Return gifts - round to nearest 10
      if (!(quantity >= 10 && quantity % 10 === 0)) {
        quantity = Math.max(10, Math.round(quantity / 10) * 10);
      }
    } else {
      // Regular products - round to nearest step
      quantity = Math.max(min, Math.round(quantity / step) * step);
    }
  }  // Allow 0 for remove

  this.enableLoading(line);
    const sections = this.getSectionsToRender().map((section) => section.section);

    const body = JSON.stringify({
      line,
      quantity,
      sections: sections,
      sections_url: window.location.pathname
    });

    fetch(`${theme.routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (parsedState.errors) {
          this.updateErrorLiveRegions(line, parsedState.errors);
        }
        this.getSectionsToRender().forEach((section => {
          const element = document.getElementById(section.id);
          if (element) {
            const elementToReplace = element.querySelector(section.selector) || element;

            if (elementToReplace && parsedState.sections[section.section]) {
              elementToReplace.innerHTML =
                this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
            }
          }
        }));
        
        this.updateQuantityLiveRegions(line, parsedState.item_count);
        
        const lineItem = document.getElementById(`CartItem-${line}`);
        if (lineItem && name) lineItem.querySelector(`[name="${name}"]`).focus();
        this.disableLoading();

        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: {
            cart: state
          }
        }));
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items' });
      })
      .catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        this.disableLoading();
        if (this.cartErrors) {
          this.cartErrors.textContent = theme.cartStrings.error;
        }
      });
  }
  
  updateErrorLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;
  
    this.lineItemStatusElement.setAttribute('aria-hidden', true);
  
    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);
  
    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }
  
  updateQuantityLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const quantityError = document.getElementById(`Line-item-error-${line}`);
      if (quantityError) {
        // Get the line item to check product type and tags (main cart)
        const lineItem = document.getElementById(`CartItem-${line}`);
        let errorMessage = theme.cartStrings.quantityError;
        let productType = null;
        let productTags = [];

        // Main cart: read from #CartItem-{line}
        if (lineItem && lineItem.dataset.productType) {
          productType = lineItem.dataset.productType;
          // Get product tags from data attribute
          if (lineItem.dataset.productTags) {
            productTags = lineItem.dataset.productTags.split(',').map(tag => tag.trim());
          }
        } else {
          // Mini-cart: find the input by data-index, then get its container's data-product-type
          const miniInput = document.querySelector(`input[name="updates[]"][data-index="${line}"]`);
          const container = miniInput ? miniInput.closest('[data-product-type]') : null;
          if (container && container.dataset.productType) {
            productType = container.dataset.productType;
            // Get product tags from data attribute
            if (container.dataset.productTags) {
              productTags = container.dataset.productTags.split(',').map(tag => tag.trim());
            }
          }
        }

        // Check for tag-based error messages first (highest priority)
        const hasMin300Tag = productTags.includes('min300');
        const hasMin200Tag = productTags.includes('min200');

        if (hasMin300Tag) {
          errorMessage = 'You can only add multiples of 100 of this item to your cart (minimum: 300)';
        } else if (hasMin200Tag) {
          errorMessage = 'You can only add multiples of 100 of this item to your cart (minimum: 200)';
        } else if (productType) {
          // Check product type-based error messages (lower priority)
          const typeLower = productType.toLowerCase();
          if (typeLower.includes('return gift') || typeLower.includes('return-gift') ||
              typeLower.includes('returngift') || typeLower.includes('return gifts') ||
              typeLower.includes('return-gifts') || typeLower.includes('returngifts') ||
              typeLower.includes('return_gift') || typeLower.includes('return_gifts')) {
            // Custom error message for Return Gifts products
            errorMessage = 'You can only add multiples of 10 of this item to your cart (minimum: 10)';
          } else if (typeLower.includes('paper')) {
            // Custom error message for Paper products
            errorMessage = 'You can only add multiples of 100 of this item to your cart (minimum: 100)';
          } else if (typeLower.includes('wedding card') || typeLower.includes('wedding-card') ||
                     typeLower.includes('weddingcard') || typeLower.includes('wedding cards') ||
                     typeLower.includes('wedding-cards') || typeLower.includes('weddingcards')) {
            // Custom error message for Wedding Cards products
            errorMessage = 'You can only add multiples of 50 of this item to your cart (minimum: 100)';
          } else if (typeLower.includes('sale')) {
            // Custom error message for Sale products
            errorMessage = 'You can only add multiples of 50 of this item to your cart (minimum: 100)';
          }
        }
        
        quantityError.querySelector('.cart-item__error-text')
          .innerHTML = errorMessage.replace(
            '[quantity]',
            document.getElementById(`Quantity-${line}`).value
          ); 
      }
    }

    this.currentItemCount = itemCount;
    
    if (this.lineItemStatusElement) this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text');
    if (cartStatus) {
      cartStatus.setAttribute('aria-hidden', false);

      setTimeout(() => {
        cartStatus.setAttribute('aria-hidden', true);
      }, 1e3);
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector)?.innerHTML;
  }

  enableLoading(line) {
    const cartItems = document.getElementById('main-cart-items');
    if (cartItems) cartItems.classList.add('cart__items--disabled');

    const loadingOverlay = this.querySelectorAll('.loading-overlay')[line - 1];
    if (loadingOverlay) loadingOverlay.classList.remove('hidden');
    
    document.activeElement.blur();
    if (this.lineItemStatusElement) this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    const cartItems = document.getElementById('main-cart-items');
    if (cartItems) cartItems.classList.remove('cart__items--disabled');
  }

  renderContents(parsedState) {
    this.getSectionsToRender().forEach((section => {
      const element = document.getElementById(section.id);

      if (element) {
        element.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));
  }
}
customElements.define('cart-items', CartItems);

class CartNote extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('change', debounce((event) => {
      const body = JSON.stringify({ note: event.target.value });
      fetch(`${theme.routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
    }, 300));
  }
}
customElements.define('cart-note', CartNote);

class DiscountCode extends HTMLElement {
  constructor() {
    super();

    if (isStorageSupported('session')) {
      this.setupDiscount();

      this.addEventListener('change', (event) => {
        window.sessionStorage.setItem('discount', event.target.value);
      });
    }
  }

  setupDiscount() {
    const discount = window.sessionStorage.getItem('discount');
    if (discount !== null) {
      this.querySelector('input[name="discount"]').value = discount;
    }
  }
}

customElements.define('discount-code', DiscountCode);

class ShippingCalculator extends HTMLElement {
  constructor() {
    super();

    this.setupCountries();
    
    this.errors = this.querySelector('#ShippingCalculatorErrors');
    this.success = this.querySelector('#ShippingCalculatorSuccess');
    this.zip = this.querySelector('#ShippingCalculatorZip');
    this.country = this.querySelector('#ShippingCalculatorCountry');
    this.province = this.querySelector('#ShippingCalculatorProvince');
    this.button = this.querySelector('button');
    this.button.addEventListener('click', this.onSubmitHandler.bind(this));
  }

  setupCountries() {
    if (Shopify && Shopify.CountryProvinceSelector) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector('ShippingCalculatorCountry', 'ShippingCalculatorProvince', {
        hideElement: 'ShippingCalculatorProvinceContainer'
      });
    }
  }

  onSubmitHandler(event) {
    event.preventDefault();
    
    this.errors.classList.add('hidden');
    this.success.classList.add('hidden');
    this.zip.classList.remove('invalid');
    this.country.classList.remove('invalid');
    this.province.classList.remove('invalid');
    this.button.classList.add('loading');
    this.button.setAttribute('disabled', true);

    const body = JSON.stringify({
      shipping_address: {
        zip: this.zip.value,
        country: this.country.value,
        province: this.province.value
      }
    });
    let sectionUrl = `${theme.routes.cart_url}/shipping_rates.json`;

    // remove double `/` in case shop might have /en or language in URL
    sectionUrl = sectionUrl.replace('//', '/');

    fetch(sectionUrl, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((parsedState) => {
        if (parsedState.shipping_rates) {
          this.success.classList.remove('hidden');
          this.success.innerHTML = '';
          
          parsedState.shipping_rates.forEach((rate) => {
            const child = document.createElement('p');
            child.innerHTML = `${rate.name}: ${rate.price} ${Shopify.currency.active}`;
            this.success.appendChild(child);
          });
        }
        else {
          let errors = [];
          Object.entries(parsedState).forEach(([attribute, messages]) => {
            errors.push(`${attribute.charAt(0).toUpperCase() + attribute.slice(1)} ${messages[0]}`);
          });

          this.errors.classList.remove('hidden');
          this.errors.querySelector('.errors').innerHTML = errors.join('; ');
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.button.classList.remove('loading');
        this.button.removeAttribute('disabled');
      });
  }
}

customElements.define('shipping-calculator', ShippingCalculator);
